import React, { FC, useEffect, useRef } from 'react'

/**
 * Helper component which will add alts into the images
 */
export const DangerouslySetInnerHTML: FC<{ content: string }> = ({
  content
}) => {
  const ref = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (ref.current) {
      for (const el of Array.from(ref.current.querySelectorAll('img'))) {
        el.alt = el.alt || `Image ${document.title ? document.title : ''}`
      }
    }
  }, [ref.current])

  return (
    <div
      ref={ref}
      dangerouslySetInnerHTML={{
        __html: content
      }}
    />
  )
}

/**
 * String Remove any h tag and image
 */
export function StripHTMLTags(string: string): string {
  const regex = /(<h)([0-6])/gi
  const regex2 = /(<\/h)([0-6])/gi
  return string
    ?.replace(regex, '<div')
    .replace(regex2, '</div')
    .replace(/<img .*?>/g, '')
}
